export default __webpack_public_path__ + "static/media/Kanha-National-Park-Travel-Guide.de615e17.jpg";